import { useSelector } from 'react-redux';
import { Route, Switch, useParams } from 'react-router-dom';

import { PageContextProvider } from 'components/Pages/Admin/PageTypes/shared/context';
import ErrorScreen from 'components/shared/ErrorScreen';
import { PAGE_DETAILS_PATH, PAGE_LANDING_PATH, PAGE_RESOURCES_PATH, PAGE_ROOMS_PATH } from 'constants/routes';
import { usePageHook } from 'hooks/pages/usePageHook';
import useUnsavedChangesHistoryBlocker from 'hooks/pages/useUnsavedChangesHistoryBlocker';
import useTheme from 'hooks/useTheme';
import { pageDataSelector } from 'store/page/selectors';
import { mapLibType2Theme } from 'utils/map';

import FormLayout from '../../Layouts/Form';
import Details from '../../Pages/Admin/Page/Details';
import Landing from '../../Pages/Admin/Page/Landing';
import Resources from '../../Pages/Admin/Page/Resources';
import Rooms from '../../Pages/Admin/Page/Rooms';
import Backdrop from '../../shared/Backdrop';
import Loader from '../../shared/Loader';

function PageRoute() {
  const page = useSelector(pageDataSelector);
  const { loading, error } = usePageHook(page);
  const { libType } = useParams();
  const theme = mapLibType2Theme(libType);
  useUnsavedChangesHistoryBlocker();
  useTheme(theme);

  if (loading) {
    return (
      <Backdrop isOpen>
        <Loader />
      </Backdrop>
    );
  }

  if (error) {
    return <ErrorScreen status="404" />;
  }

  if (!page.type) {
    return null;
  }

  return (
    <PageContextProvider page={page}>
      <FormLayout type="page">
        <Switch>
          <Route path={PAGE_DETAILS_PATH} component={Details} exact />
          <Route path={PAGE_RESOURCES_PATH} component={Resources} exact />
          <Route path={PAGE_ROOMS_PATH} component={Rooms} exact />
          <Route path={PAGE_LANDING_PATH} component={Landing} exact />

          <Route render={() => <ErrorScreen status="404" />} />
        </Switch>
      </FormLayout>
    </PageContextProvider>
  );
}

export default PageRoute;
